import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { LABEL } from '../../theme/constants';
import { userRoleCodeToRole, getSelectedUserTypeFromStore } from '../../auth/helper';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles()({
  root: {
    minWidth: 375,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function ProfileDialog(props) {
  const { classes } = useStyles();
  const bull = <span className={classes.bullet}>•</span>;
  const { openDialog, userProfile } = props;
  const [open, setOpen] = React.useState(openDialog);
  const [enter, setEnter] = React.useState(0);
  const selectedUserType = getSelectedUserTypeFromStore();

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (enter === 0) return;
    setOpen(true);
  }, [openDialog]);

  React.useEffect(() => {
    setEnter(1);
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="profile-dialog-slide-title"
        aria-describedby="profile-dialog-slide-description"
      >
        <DialogTitle id="profile-dialog-slide-title">{LABEL.ORGANISATION_INFO}</DialogTitle>
        <DialogContent>
          <div id="profile-dialog-slide-description">
            <Card className={classes.root}>
              <CardContent>
                {userProfile.firstName && userProfile.lastName && (
                  <>
                    <Typography variant="h6" component="span">
                      {bull}
                      {LABEL.USERNAME_LABEL}
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                      {userProfile.firstName == null ? '' : userProfile.firstName}{' '}
                      {userProfile.lastName == null ? '' : userProfile.lastName}
                    </Typography>
                  </>
                )}
                <Typography variant="h6" component="span">
                  {bull}
                  {LABEL.COMPANY_NXTENTITYID}
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  {userProfile.nxtEntityId}
                </Typography>

                <Typography variant="h6" component="span" color="textSecondary">
                  {bull}
                  {LABEL.USER_ROLE_LABEL}
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  {userRoleCodeToRole(selectedUserType)}
                </Typography>
              </CardContent>
            </Card>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {LABEL.CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
